import { useSelector } from 'react-redux';
import { selectPage } from '../../selectors/analytics';
import { selectBannerPopup } from '../../selectors/promosPage';

import { useApplicationContext } from '../../utils/applicationContext';
import { ESiteType } from '../../utils/siteType';

export const useNewbuildingListingUrl = (): null | string => {
  const { config } = useApplicationContext();
  const isNewFiltersEnabled = config.get<boolean>('newbuildingDiscountMortgage.Enabled');
  const popup = useSelector(selectBannerPopup);
  const page = useSelector(selectPage);
  const { siteType } = page;

  if (!popup) {
    return null;
  }

  if (isNewFiltersEnabled && siteType === ESiteType.mobile) {
    return popup.newbuildingListingUrlMobile;
  }

  if (isNewFiltersEnabled && (siteType === ESiteType.desktop || siteType === ESiteType.tablet)) {
    return popup.newbuildingListingUrlDesktop;
  }

  return popup.newbuildingListingUrl;
};
